import React from 'react';
import { Search, Home, MessageSquare, PlayCircle, Settings, HelpCircle, Banknote, LogOut, Eye, Zap, Folder } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

interface SidebarProps {
  onLogout: () => void;
}

const Sidebar = ({ onLogout }: SidebarProps) => {
  const location = useLocation();
  const menuItems = [
    { icon: Home, label: 'Home', href: '/app/home' },
    { icon: MessageSquare, label: 'Chat', href: '/app/chat', badge: 'New' },
    { icon: Banknote, label: 'Finanças', href: '/app/finances' },
    { icon: Eye, label: 'Vision', href: '/app/vision' },
    { icon: PlayCircle, label: 'Entretenimento', href: '/app/entertainment' },
    { icon: Folder, label: 'Projetos', href: '/app/projects', badge: 'AI' },
    { icon: Zap, label: 'Legatia', href: '/app/legatia', badge: 'Beta' },
  ];

  const isActive = (href: string) => location.pathname === href;

  return (
    <div className="w-64 bg-[#111]/80 backdrop-blur-xl border-r border-white/[0.08] font-everett">
      {/* Logo */}
      <div className="h-20 flex items-center justify-center">
        <img 
          src="/images/Logo branca e icone.svg" 
          alt="LegatIA Logo" 
          className="h-[32px] object-contain"
        />
      </div>

      {/* Search */}
      <div className="px-4 py-4">
        <div className="relative">
          <Search className="w-4 h-4 absolute left-4 top-1/2 transform -translate-y-1/2 text-[#8E95A3]" />
          <input
            type="text"
            placeholder="Buscar..."
            className="w-full h-[48px] pl-12 pr-4 bg-white/[0.08] rounded-xl text-[14px] text-white placeholder-[#8E95A3] focus:outline-none focus:ring-2 focus:ring-white/[0.12] focus:bg-white/[0.12] transition-all"
          />
        </div>
      </div>

      {/* Menu */}
      <nav className="px-4 py-4 space-y-2">
        {menuItems.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            className={`flex items-center px-4 h-[48px] rounded-xl transition-all ${
              isActive(item.href)
                ? 'bg-white text-black'
                : 'text-white/60 hover:bg-white/[0.08]'
            }`}
          >
            <item.icon className={`w-5 h-5 mr-3 ${isActive(item.href) ? 'text-black' : ''}`} />
            <span className="text-[14px]">{item.label}</span>
            {item.badge && (
              <span className={`ml-auto px-3 py-1 text-[12px] rounded-full ${
                isActive(item.href)
                  ? 'bg-black text-white'
                  : 'bg-white/[0.08] text-white'
              }`}>
                {item.badge}
              </span>
            )}
          </Link>
        ))}
      </nav>

      {/* Footer */}
      <div className="absolute bottom-0 w-full border-t border-white/[0.08] px-4 py-4">
        <button
          onClick={onLogout}
          className="flex items-center w-full px-4 h-[48px] rounded-xl text-white/60 hover:bg-white/[0.08] transition-all"
        >
          <LogOut className="w-5 h-5 mr-3" />
          <span className="text-[14px]">Sair</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
